import { Checkbox, CheckboxProps } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, UseWatchProps } from 'react-hook-form';

interface ICheckboxWithControllerProps {
  name: string;
  hookFormProps?: Omit<UseWatchProps<any>, 'name' | 'render'>;
  checkboxProps?: Omit<CheckboxProps, 'checked' | 'onChange'>;
}

/**
 * Checkbox с react-hook-forms Controller (без лейбла)
 *
 * @param name - для react-hook-forms Controller
 * @param checkboxProps
 * @param hookFormProps
 */
export const CheckboxWithController: React.FC<ICheckboxWithControllerProps> = (props) => {
  const { name, checkboxProps, hookFormProps } = props;

  const { control } = useFormContext();

  const { onClick, ...restCheckboxProps } = checkboxProps || {};

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <Checkbox
          checked={!!field.value}
          onChange={field.onChange}
          onClick={(event) => {
            event.stopPropagation();
            onClick?.(event);
          }}
          sx={(theme) => ({
            color: theme.palette.custom.icon.gray,
            backgroundColor: theme.palette.background.paper,
            padding: 0,
            borderRadius: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 28,
            height: 28,
          })}
          {...restCheckboxProps}
        />
      )}
      {...hookFormProps}
      control={hookFormProps?.control || control}
    />
  );
};
